import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import SplashComponent from "./layouts/splash/splash.component";

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SplashComponent],
  templateUrl: './app.component.html',
})
export class AppComponent {
  title = 'aljhamar';
}
